'use client';

import FaIcon, { faInstagram, faXTwitter } from '@/components/icon/FaIcon/FaIcon';
import LoadingLink from '@/components/ui/LoadingLink/LoadingLink';
import { SERVICE_OFFICIAL_SNS_URL_INSTAGRAM, SERVICE_OFFICIAL_SNS_URL_X } from '@/constants';
import layoutStyles from '@/styles/modules/layout.module.scss';
import utilsStyles from '@/styles/modules/utils.module.scss';
import logoWhite from '/public/logo-white.png';
import pMarkImage from '/public/p-mark-white.png';
import styles from './CommonFooter.module.scss';

function CommonFooter({
  siteName,
}: {
  siteName: string;
}) {
  return (
    <footer className={styles.componentStyle}>
      <div className={`${layoutStyles.gfPageContainerLarge} ${styles.container}`}>
        <div className={styles.footerLogo}>
          <LoadingLink href='/' prefetch={false}>
            <img src={logoWhite.src} alt={siteName} />
          </LoadingLink>
        </div>
        <div className={styles.menuContainer}>
          <div className={styles.menuGroup}>
            <LoadingLink href='/user-designs' prefetch={false}>
              みんなのデザイン
            </LoadingLink>
            <LoadingLink href='/works?sort=created_at_desc' prefetch={false}>
              作品一覧
            </LoadingLink>
            <LoadingLink href='/product' prefetch={false}>
              アイテム一覧
            </LoadingLink>
            <LoadingLink href='/favorite-material' prefetch={false}>
              お気に入りのコマ
            </LoadingLink>
          </div>
          <div className={styles.menuGroup}>
            <LoadingLink href='/about' prefetch={false}>
              ジャンプLABとは
            </LoadingLink>
            <LoadingLink href='/informations' prefetch={false}>
              お知らせ
            </LoadingLink>
            <LoadingLink href='/faq' prefetch={false}>
              FAQ
            </LoadingLink>
            <LoadingLink href='/guide' prefetch={false}>
              ご利用ガイド
            </LoadingLink>
            <LoadingLink href='/contact' prefetch={false}>
              お問い合わせ
            </LoadingLink>
          </div>
          <div className={styles.menuGroup}>
            <LoadingLink href='/terms' prefetch={false}>
              利用規約
            </LoadingLink>
            <a href='https://fogg.jp/privacy' target='_blank' rel='noopener noreferrer'>
              個人情報保護方針
            </a>
            <LoadingLink href='/purchase-terms' prefetch={false}>
              購買規約
            </LoadingLink>
            <LoadingLink href='/design-annotation' prefetch={false}>
              ご購入前の確認事項について
            </LoadingLink>
            <LoadingLink href='/policy' prefetch={false}>
              個人情報の取扱いについて
            </LoadingLink>
            <LoadingLink href='/tokusho' prefetch={false}>
              特定商取引法に基づく表記
            </LoadingLink>
          </div>
        </div>
        <div className={styles.snsAndPMarkWrapper}>
          <div className={styles.snsContainer}>
            <p className={styles.snsTitle}>
              作品追加や新着情報などを
              <br className={utilsStyles.onlyPc} />
              公式SNSでチェック！
            </p>
            <div className={styles.snsLinks}>
              <a href={SERVICE_OFFICIAL_SNS_URL_X} target='_blank' rel='noopener noreferrer' className={styles.snsLink}>
                <div className={styles.snsIcon}>
                  <FaIcon icon={faXTwitter} />
                </div>
              </a>
              <a
                href={SERVICE_OFFICIAL_SNS_URL_INSTAGRAM}
                target='_blank'
                rel='noopener noreferrer'
                className={styles.snsLink}
              >
                <div className={styles.snsIcon}>
                  <FaIcon icon={faInstagram} />
                </div>
              </a>
            </div>
          </div>
          <div className={styles.pMark}>
            <a href='https://privacymark.jp/' target='_blank' rel='noopener noreferrer'>
              <img src={pMarkImage.src} alt='プライバシーマーク' />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default CommonFooter;
